<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 :class="$style['section']">
                <br>
                <p>This marriage application worksheet is to be filled in as preparation to an application for a marriage license at a County Clerk office. This is NOT a marriage application, or license, or certificate. This worksheet will be available to the selected County Clerk office to speed the process for a marriage license application, and ease the burden of documentation. Marriage applicants should upload any relevant documentation to this worksheet. This includes photo identification, birth, divorce or death certificates, and age applicable court orders.</p>
                <p>Select the county in which you will be applying for a marriage license, and fill in the entire worksheet. At the end, upload your documentation as applicable and acknowledge the requirements for your license application, then click Submit. You will not be able to edit any fields after submission. Your worksheet information will be securely stored in the VSS system for retrieval by your selected County Clerk office when you apply.</p>
                <p>Contact your desired County Clerk office for more information on how to apply for your marriage license. Be sure to let them know you've filled out the marriage application worksheet online and uploaded your documentation as required.</p>
            </v-flex>
            <!-- <v-flex xs12 :class="$style['section']">
                <h4>Obtaining a Marriage License</h4>
                <p :class="$style['section-body']">
                    To obtain a marriage license in Wyoming, couples must appear in person to the County Clerk, <span :class="$style['text-red']"> be 18 years of age or older, present a photo ID - Driver's License, Passport, Military ID, or tribal ID, and divorce or death certificate, if applicable. Applicants that are 16 or 17 must have written consent of guardian and a competent witness, and court order. </span>
                </p>
            </v-flex>
            <v-flex xs12 lg6 :class="$style['section']">
                <h4>Information needed to apply for license</h4>
                <ul>
                    <li><p>Both parties must be present to obtain a license.</p></li>
                    <li><p>Full legal name.</p></li>
                    <li><p>Current residential address.</p></li>
                    <li><p>State of foreign country of birth.</p></li>
                    <li><p>Date of birth.</p></li>
                    <li><p>Social Security Number.</p></li>
                    <li><p>Parent's names and mother's maiden name.</p></li>
                    <li><p>State or foreign country which where parents were born.</p></li>
                    <li><p>Divorce or death date death and location, if previously married.</p></li>
                </ul>
            </v-flex>
            <v-flex xs12 lg6 :class="$style['section']">
                <h4>Fees</h4>
                <table>
                    <tr>
                        <td><p>* Marriage License</p></td>
                        <td><p>$30.00</p></td>
                    </tr>
                    <tr>
                        <td><p>* Copy of Marriage License if lost</p></td>
                        <td><p>$5.00</p></td>
                    </tr>
                    <tr>
                        <td><p>* Unofficial photocopy of Marriage License</p></td>
                        <td><p>$1.00</p></td>
                    </tr>
                </table>
                <p>Payable to issuing County Clerk office.</p>
                <h4>Additional Information</h4>
                <ul>
                    <li><p>* Within 10 (ten) days after the ceremony, the completed license must be returned to the issuing County Clerk's office. The license may be used anywhere in the State of Wyoming, but must be returned to the issuing office.</p></li>
                    <li><p>* Licenses can only be used in the State of Wyoming. The marriage license will expire one year from the date of issuance.</p></li>
                </ul>
            </v-flex>
            <v-flex xs12 :class="$style['section']">
                <h4>Civil Ceremony Information</h4>
                <ul>
                    <li><p>We do not require documentation about an officiant's credentials; however, they must qualify by statute W.S. 20-1-106</p></li>
                    <li><p>Who may solemnize marriage; form of ceremony.</p></li>
                    <li><p>(a) Every district or circuit court judge, district court commissioner, supreme court justice, magistrate and every licensed or ordained minister of the gospel, bishop, priest or rabbi, or other qualified person acting in accordance with the traditions or rites for the solemnization of marriage of any religion, denomination or religious society, may perform the ceremony of marriage in this state.</p></li>
                    <li><p>(b) In the solemnization of marriage no particular form is required, except that the parties shall solemnly declare in the presence of the person performing the ceremony and at least two (2) attending witnesses that they take each other as husband and wife.</p></li>
                </ul>
            </v-flex> -->
        </v-layout>
    </div>
</template>

<script>
export default {
    name: 'marriage-ws-header'
}
</script>

<style scoped>
    /* h4 {
        font-weight: 500 !important;
    }

    ul {
        list-style-type: none;
    }

    li {
        margin:  0px 0px -8px -23px;
    }

    tr {
        line-height: 8px;
    }

    td {
        padding-right: 25px;
    } */
</style>

<style module>
    .section {
        padding: 0px 4px 0px 4px;
    }

    .text-red {
        color: red;
    }
</style>
